'use strict';

export default angular
  .module('maestro.directives.common.repeat-complete', [])

  .directive('repeatComplete', function($timeout) {
    return function(scope, element, attrs) {
      if (scope.$last) { // all are rendered
        $timeout(function() {
          scope.$eval(attrs.repeatComplete);
        }, 0);
      }
    };
  })

  .name;
